import {GoftinoSnippet, IGetMessage} from '@mohsen007/react-goftino';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import CircleIcon from '@mui/icons-material/Circle';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import SettingsPowerOutlinedIcon from '@mui/icons-material/SettingsPowerOutlined';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
import {Box, Grid} from '@mui/material';
import {useEffect, useState} from 'react';
import {useMutation} from 'react-query';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import version from '../../../../package.json';
import IconTitleCard from '../../../components/card/profileCard/iconTitleCard';
import ProfileCard from '../../../components/card/profileCard/profileCard';
import ConfirmDeleteModal from '../../../components/modal/confirmDeleteModal';
import {
    EXTERNAL_PROVIDE,
    GATEWAY_PAYMENT_TOKEN,
} from '../../../config/cacheKey';
import {IGetCustomerInfoResponse} from '../../../models/customer.model';
import {setHeaderTitle} from '../../../redux/headerTitle/headerTitleSlice';
import {SetGoftinoUser} from '../../../services/account.service';
import {setJwtToken} from '../../../services/auth.service';

declare global {
    interface Window {
        Goftino: any;
    }
}

// cards
//route from kaman

const Profile = ({
    setState,
    setTabChild,
    profile,
}: {
    setState: (state: 'profile' | 'support' | 'userProfile') => void;
    setTabChild: any;
    profile: IGetCustomerInfoResponse;
}) => {
    const navigate = useNavigate();
    const [providerToken, setProviderToken] = useState<string | null>(null);

    useEffect(() => {
        const token = sessionStorage.getItem(EXTERNAL_PROVIDE);
        setProviderToken(token);
    }, []);
    const allCard = [
        {
            title: 'مشاهده اقساط',
            icon: <MonetizationOnOutlinedIcon />,
            id: 'loans',
        },
        {
            title: 'کیف پول',
            icon: <AccountBalanceWalletOutlinedIcon />,
            id: 'wallet',
        },
        {title: 'گفتگوی آنلاین', icon: <ForumOutlinedIcon />, id: 'onlineTalk'},
        {title: 'پشتیبانی', icon: <SupportAgentOutlinedIcon />, id: 'support'},
        {
            title: 'خروج از سیستم',
            icon: <SettingsPowerOutlinedIcon />,
            id: 'logout',
        },
    ];
    const cards = providerToken
        ? allCard.filter((card) => card.id !== 'logout')
        : allCard;
    const [openVerifyModal, setOpenVerifyModal] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [unreadMessages, setUnreadMessages] = useState(false);

    const dispatch = useDispatch();
    const handleClick = (id: string) => {
        if (id === 'onlineTalk') {
            window.Goftino.open();
            setUnreadMessages(false);
        } else if (id === 'logout') {
            setOpenVerifyModal(true);
        } else if (id === 'loans') {
            navigate('/loans');
        } else if (id === 'support') {
            navigate('/account/support');
        } else if (id === 'wallet') {
            navigate('/market/wallet');
        }
    };

    const {mutate: SetGoftinoUserMutate} = useMutation(SetGoftinoUser, {
        onSuccess: (data: boolean) => {
            if (data) {
            }
        },
        onError: () => {},
    });

    useEffect(() => {
        dispatch(setHeaderTitle({display: 'none', color: '#0158CC'}));
    }, []);

    useEffect(() => {
        if (confirm) {
            setJwtToken('', '');
            window.location.href = '/';
            sessionStorage.clear();
            localStorage.removeItem(GATEWAY_PAYMENT_TOKEN);
        }
    }, [confirm]);

    return (
        <Grid
            container
            flexDirection={'column'}
            height={'calc(100svh - 60px)'}
            sx={{position: 'relative'}}
        >
            <Grid
                item
                height={'20%'}
                sx={{
                    background: '#0158CC',
                    position: 'relative',
                    '@media (min-width: 550px)': {borderRadius: '0px'},
                }}
                className="mediaCardInfoDrawer"
            ></Grid>
            <Grid
                item
                height={'100%'}
                sx={{
                    width: '100%',
                    top: '8vh',
                    position: 'absolute',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'column',
                }}
            >
                <Box>
                    <Box>
                        <ProfileCard
                            genderType={profile?.genderType}
                            fullName={profile?.fullName!}
                            nationalCode={profile?.nationalCode!}
                            birthDatePersian={profile?.birthDatePersian!}
                            mobileNumber={profile?.mobileNumber!}
                            setState={setState}
                            goftinoUserId={profile?.goftinoUserId}
                        />
                    </Box>
                    <Box
                        sx={{
                            paddingInline: '20px',
                            marginTop: '20px',
                            maxHeight: 'calc(100svh - 60%)',
                            height: '100%',
                            overflowY: 'auto',
                        }}
                    >
                        {cards.map((card, index) => (
                            <span
                                onClick={() => handleClick(card.id)}
                                key={index}
                            >
                                <IconTitleCard
                                    icon={
                                        <>
                                            {card.icon}
                                            {unreadMessages &&
                                                card.id === 'onlineTalk' && (
                                                    <CircleIcon
                                                        sx={{
                                                            color: '#FF617C',
                                                            fontSize: '.7rem',
                                                            position:
                                                                'absolute',
                                                            top: '-3px',
                                                            right: '-3px',
                                                        }}
                                                    />
                                                )}
                                        </>
                                    }
                                    title={card.title}
                                />
                            </span>
                        ))}
                    </Box>
                </Box>
                <Box
                    sx={{
                        position: 'fixed',
                        bottom: 65,
                        right: '0px',
                        margin: 'auto',
                        width: '100%',
                    }}
                >
                    <div
                        style={{
                            color: '#716e6e7a',
                            opacity: '0.9',
                            textAlign: 'center',
                            fontSize: '0.7rem',
                        }}
                    >
                        <span style={{fontSize: '.7rem'}}>نسخه:</span>&nbsp;
                        {version.version}
                    </div>
                </Box>
                {profile?.nationalCode && (
                    <GoftinoSnippet
                        goftinoKey={'qzVes1'}
                        onReady={() => {
                            window.Goftino.getUserId();
                            window.Goftino.setUser({
                                name: profile?.fullName,
                                phone: profile?.mobileNumber,
                            });
                            window.Goftino.setWidget({
                                hasIcon: false,
                            });
                            if (!profile?.goftinoUserId) {
                                SetGoftinoUserMutate({
                                    goftinoUserId: window.Goftino.getUserId(),
                                });
                            } else {
                                window.Goftino.setUserId(
                                    profile?.goftinoUserId
                                );
                            }
                        }}
                        onGetMessage={(message: IGetMessage) => {
                            setUnreadMessages(true);
                        }}
                    />
                )}

                <ConfirmDeleteModal
                    text={'آیا میخواهید از برنامه خارج شوید؟'}
                    buttonTitle={'خروج'}
                    delButton={true}
                    openModal={openVerifyModal}
                    setOpenVerifyModal={setOpenVerifyModal}
                    setConfirm={setConfirm}
                />
            </Grid>
        </Grid>
    );
};

export default Profile;
